var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Head',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.show),expression:"$route.meta.show"}]}),_c('router-view'),_c('Food',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.show),expression:"$route.meta.show"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }